// src/pages/ProjectFigma.jsx
import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import '../styles/ProjectPage.css';
import { projectsData } from '../data/projects';

export default function ProjectFigma() {
    const { id } = useParams();
    const project = projectsData.find((p) => p.id === id && p.figmaEmbedSrc);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (!project) return <Navigate to="/" />;

    return (
        <div className="project-page">
            <main className="project-main figma-project-main">
                <div className="figma-embed-wrapper">
                    <iframe
                        className="figma-embed"
                        src={project.figmaEmbedSrc}
                        title={`Maquette Figma – ${project.title}`}
                        allowFullScreen
                    />
                </div>

                <div className="project-content">
                    <h1>{project.title}</h1>
                    <p className="project-desc">{project.desc}</p>

                    {project.tech?.length > 0 && (
                        <div className="project-tech">
                            <h3>Compétences</h3>
                            <ul>
                                {project.tech.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    <div className="project-actions">
                        <a href={project.figmaUrl} target="_blank" rel="noopener noreferrer" className="back-btn">
                            Ouvrir dans Figma ↗
                        </a>
                    </div>
                </div>
            </main>
        </div>
    );
}
